import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { ReactElement } from 'react';
import { StyledComponent } from '@emotion/styled';

export const LightTooltip: StyledComponent<TooltipProps> = styled(({ className, ...props }: TooltipProps): ReactElement => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.common.white,
		color: 'rgba(0, 0, 0, 0.87)',
		boxShadow: theme.shadows[1],
		fontSize: theme.typography.pxToRem(11),
	},
}));

export const BootstrapTooltip: StyledComponent<TooltipProps> = styled(({ className, ...props }: TooltipProps): ReactElement => (
	<Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: theme.palette.common.black,
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.common.black,
	},
}));

export const HtmlTooltip: StyledComponent<TooltipProps> = styled(({ className, ...props }: TooltipProps): ReactElement => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#000',
		color: 'rgba(255, 255, 255, 0.87)',
		//maxWidth: 220,
		fontSize: theme.typography.pxToRem(20),
		border: '1px solid #dadde9',
	},
}));
